import { render } from "./A105060.vue?vue&type=template&id=6e4c519c&scoped=true"
import script from "./A105060.vue?vue&type=script&lang=js"
export * from "./A105060.vue?vue&type=script&lang=js"

import "./A105060.vue?vue&type=style&index=0&id=6e4c519c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4c519c"]])

export default __exports__